import Ajax from "@/api/ajax";
export default{
    //测试
    bigShop_add(params) {
        return Ajax.post("/Home/get_web_navigation", params);
    },
    buyFeeBaoYue(params) { //购买转账手续费包月
        return Ajax.post('/Home/buyTransfeeBaoYue', params);
      },
    // 自营商城
    yueyangMallCategory(params) {
      // 商品分类(树形)
      return Ajax.post("/Home/yueyangMallCategory", params);
    },
    yueyangMallCategoryHome(params) {
      // 首页展示分类(平铺)
      return Ajax.post("/Home/yueyangMallCategoryHome", params);
    },
    yueyangMallGoodsList(params) {
      // 商品列表
      return Ajax.post("/Home/yueyangMallGoodsList", params);
    },
    yueyangMallGoodsDetail(params) {
      // 商品详情
      return Ajax.post("/Home/yueyangMallGoodsDetail", params);
    },
    yueyangMallAddCart(params) {
      // 加入购物车
      return Ajax.post("/Home/yueyangMallAddCart", params);
    },
    yueyangMallCartGoodsPreview(params) {
      // 购物车商品预览
      return Ajax.post("/Home/yueyangMallCartGoodsPreview", params);
    },
    yueyangMallCalcShippingFee(params) {
      // 计算运费
      return Ajax.post("/Home/yueyangMallCalcShippingFee", params);
    },
    yueyangMallCreateOrder(params) {
      // 创建订单
      return Ajax.post("/Home/yueyangMallCreateOrder", params);
    },
    yueyangMallPendingPayOrdersPreview(params) {
      // 待支付订单
      return Ajax.post("/Home/yueyangMallPendingPayOrdersPreview", params);
    },
    yueyangMallPayOrders(params) {
      // 订单支付
      return Ajax.post("/Home/yueyangMallPayOrders", params);
    },
    yueyangMallOrderList(params) {
      // 前台订单列表
      return Ajax.post("/Home/yueyangMallOrderList", params);
    },
    yueyangMallOrderCount(params) {
      // 前台订单数量统计
      return Ajax.post("/Home/yueyangMallOrderCount", params);
    },
    yueyangMallOrderDetail(params) {
      // 订单详情自营
      return Ajax.post("/Home/yueyangMallOrderDetail", params);
    },

    // 邀请返利接口
    inviteUsers(params) {
      return Ajax.post("/Home/inviteUsers", params);
    },
    inviteReturnCouponList(params) {
      return Ajax.post("/Home/inviteReturnCouponList", params);
    },

}